var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"cms-media-library__upload"},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("\n    "+_vm._s(_vm.localization.trans('file_drop_text'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }